module.exports = __webpack_public_path__ + "media/bootstrap-icons/stop-fill-ff37675a.svg";